// extracted by mini-css-extract-plugin
export default {"bar":"cUcx3KZL7KNWXxvBi0CW","segment":"bAXulvUf3fGorY7l_3pG"};